export { default, type Tags, FONT_CLASSES } from './Text';
